<template>
  <div class="hover-dot" :class="{'show-slide': slide}">
    <div
      class="play-icon"
      :class="{'spin-ani': this.linkAudio && this.linkAudio.isPlaying}"
      @click="slideShow"
      :style="{backgroundImage: `url(${linkAudio.icon})`}"
    ></div>
    <div class="close-btn" @click="pauseAudio"></div>
  </div>
</template>
<script>
/* eslint-disable max-len */
export default {
  props: {
    linkAudio: {
      type: Object
    }
  },
  data() {
    return {
      slide: false
    };
  },
  methods: {
    slideShow() {
      this.slide = !this.slide;
    },
    pauseAudio() {
      if (this.linkAudio.isPlaying) {
        // dom
        this.linkAudio.dom.children[2].classList.remove('pause-btn');
        // audio
        this.linkAudio.audio.pause();
      }
    }
  }
};
</script>

<style lang="scss">
@import "../css/index";
@import "../../../common/css/common-mixin";
.hover-dot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: rpx(184);
  height: rpx(120);
  right: rpx(-56);
  bottom: rpx(60);
  background: #fff;
  box-shadow: 0 0 12px #ccc;
  border-radius: rpx(60) 0 0 rpx(60);
  padding: 0 rpx(23) 0 rpx(10);
  transition: transform 0.5s;
  z-index: 10000;

  .play-icon {
    width: rpx(92);
    height: rpx(92);
    border-radius: 50%;
    background: url(../../../assets/img/hover-play-icon.png) no-repeat center /
      contain;
  }
  .close-btn {
    width: rpx(34);
    height: rpx(34);
    background: url(../../../assets/img/hover-close.png) no-repeat center /
      contain;
  }
  &.show-slide {
    transform: translateX(rpx(-56));
  }
  .spin-ani {
    animation: spin-ani 3s linear 0s infinite normal none;
  }
  @keyframes spin-ani {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3),
    only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2),
    only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3),
    only screen and (device-width: 360px) and (device-height: 780px) and (-webkit-device-pixel-ratio: 3),
    only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3),
    only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3){
    bottom: rpx(70+60);
  }
}
</style>
